var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrille(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 579,
    viewBox: "0 0 480 579",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 65.5794C44.1771 65.5794 87.8713 67.9006 130.999 65.3776C167.738 63.2346 203.042 48.6191 240 48.6191C276.959 48.6191 312.262 63.2346 349.001 65.3776C392.129 67.9006 435.823 65.5794 479 65.5794",
    stroke: "#EDE9E5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 129.411H69.3567C89.5888 129.411 111.113 131.916 131.132 128.286C168.797 121.449 201.223 87.5811 239.998 87.5811C278.772 87.5811 311.203 121.449 348.863 128.286C367.897 131.737 388.338 129.411 407.566 129.411H479",
    stroke: "#EDE9E5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 193.388C21.7665 193.632 42.5331 193.906 63.2997 194.21C82.1904 194.474 101.678 196.388 120.494 194.012C160.925 188.895 199.069 163.715 240.003 163.649C280.349 163.583 317.783 188.685 357.622 193.646C375.787 195.914 394.588 194.18 412.838 194C434.89 193.784 456.944 193.584 479 193.4",
    stroke: "#EDE9E5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 257.024C33.1868 257.145 65.3836 257.667 97.5704 257.65C145.083 257.617 192.466 252.703 239.993 252.703C285.646 252.676 331.15 257.568 376.788 257.562C410.854 257.562 444.929 257.139 479 257.046",
    stroke: "#EDE9E5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 321.262C33.1271 321.145 65.2592 320.7 97.3864 320.732C144.948 320.732 192.426 324.441 239.993 324.441C285.676 324.441 331.269 320.796 376.947 320.817C410.963 320.817 444.984 321.182 479 321.273",
    stroke: "#EDE9E5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 384.968C40.3159 384.511 81.0336 380.33 120.21 384.209C160.511 388.194 199.384 407.859 240.012 407.93C280.004 407.989 318.187 388.401 357.871 384.553C397.729 380.686 439.023 384.636 479 384.98",
    stroke: "#EDE9E5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 448.812H69.3567C89.6932 448.812 110.835 446.793 131.042 449.696C168.29 455.037 202.049 482.143 240.007 482.143C277.966 482.143 311.72 455.031 348.973 449.696C368.176 446.938 388.244 448.812 407.586 448.812H479",
    stroke: "#EDE9E5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 512.619C44.2467 512.619 87.7568 510.759 130.954 512.781C167.564 514.511 203.255 526.67 240 526.67C276.745 526.67 312.461 514.524 349.046 512.781C392.243 510.734 435.778 512.619 479 512.619",
    stroke: "#EDE9E5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M425.743 1C425.743 53.1554 423.981 105.777 425.884 157.885C427.501 202.156 439 245.026 439 289.5C439 333.974 427.485 376.844 425.879 421.115C423.996 473.229 425.743 525.839 425.743 578",
    stroke: "#EDE9E5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M372.613 1V87.2224C372.613 110.495 370.862 134.928 373.429 158.016C378.433 203.239 404.02 243.209 404 289.503C403.98 335.797 378.413 375.749 373.444 420.984C370.762 445.286 372.638 470.994 372.638 495.487V578",
    stroke: "#EDE9E5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M320.06 1C319.711 48.7303 315.937 98.5188 319.562 146.052C323.262 194.512 341.97 240.579 342 289.5C342.045 337.553 323.431 382.693 319.885 430.268C316.265 478.728 319.816 529.33 320.05 578",
    stroke: "#EDE9E5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M266.503 1C266.402 40.7434 266 80.4927 266 120.242C266 176.689 269.97 233.023 270 289.488C270.025 343.279 266.055 396.92 266.111 450.693C266.161 493.123 266.443 535.564 266.513 578",
    stroke: "#EDE9E5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M213.426 1C213.532 40.7494 213.989 80.5107 214 120.26C214 176.719 209.032 233.011 209 289.488C208.968 343.291 213.952 396.89 213.883 450.669C213.835 493.111 213.501 535.558 213.426 578",
    stroke: "#EDE9E5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M160.609 1C160.8 27.3241 161.013 53.6681 161.247 80.0321C161.433 101.857 162.991 124.412 160.991 146.123C156.513 194.775 134.045 240.172 134 289.5C133.955 338.008 156.353 382.382 160.669 430.196C162.755 453.343 161.136 477.394 161.011 500.661C160.87 526.439 160.735 552.218 160.604 578",
    stroke: "#EDE9E5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M107.252 1V87.2224C107.252 110.387 109.308 135.21 106.263 158.111C100.213 203.783 69.9753 242.306 70 289.503C70.0247 336.7 100.272 375.199 106.288 420.889C109.461 444.993 107.252 471.143 107.252 495.487V578",
    stroke: "#EDE9E5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1356 1C54.1356 53.1032 56.1938 105.912 53.9584 157.938C52.0529 202.359 38.9951 244.776 39 289.503C39.0049 334.23 52.0774 376.641 53.9632 421.062C56.174 473.112 54.1356 525.897 54.1356 578",
    stroke: "#EDE9E5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 476,
    height: 575,
    stroke: "#EDE9E5",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrille);
export default __webpack_public_path__ + "static/media/grille.b8b4d81590335daf39901b756c337878.svg";
export { ForwardRef as ReactComponent };